import { gql } from '@apollo/client';
import getConfig from 'next/config';
import client from '../../util/GraphqlClient';
import { getTokenFromCookies, setCookie, getCookie } from '../hooks/useCookie';
import { setLocalStorage } from '../hooks/useLocalStorage';

const { publicRuntimeConfig } = getConfig();
const SUBSCRIPTIONS_WITH_ELIGIBILITY_AND_CONTACT_DETAILS = gql`
  query getSubscriptionWithEligibilityAndContactDetails {
    getSubscriptionWithEligibility {
      id
      orderId
      orderReference
      status
      catalogOfferCode
      type
      tariffPlanCode
      name
      accountId
      serviceGroup
      simOnly
      acquisitionType
      addressInfo {
        addressLine1
        addressLine2
        addressLine3
        county
        code
        town
      }
      coEligiblity {
        changeOffer
        contractRenewal
        earlyCeaseChargeList {
          totalAmountVatIncluded
          error
        }
      }
      servicesForSubscription {
        name
        msisdn
        sipNumber
        dsl
        broadbandDsl
      }
    }
    getMyContactDetails {
      # identityDocuments: [IdentityDocuments]
      addresses {
        addressLine1
        addressLine2
        addressLine3
        town
        county
        eircode
        addressType
        area
        code
        country
        flatNumber
        type
        eirCode
      }
      title
      firstName
      lastName
      birthDate
      phoneNumbers {
        phoneNumber
        type
        id
      }
      emails {
        email
        type
        validated
      }
      # permissions: ContactPermission
    }
  }
`;

const CROSS_SELL_ELIGIBILTY = gql`
  query checkCrossSellEligibility(
    $accountId: Int!
    $reference: String
    $parentSubscriptionId: String
  ) {
    checkCrossSellEligibility(
      accountId: $accountId
      reference: $reference
      parentSubscriptionId: $parentSubscriptionId
    ) {
      offerTypes {
        causes
        eligible
        offerType
      }
      serviceGroups {
        causes
        eligible
        serviceGroup
      }
      error
    }
  }
`;

const CREATE_CROSS_SELL_REQUEST = gql`
  mutation createCrossSellProspect(
    $accountId: String!
    $offerType: String!
    $channel: String!
    $email: String
  ) {
    createCrossSellProspect(
      accountId: $accountId
      offerType: $offerType
      channel: $channel
      email: $email
    )
  }
`;

const GET_JOURNEY_DETAILS = gql`
  query getJourneyDetails($reference: String!) {
    getJourneyDetails(reference: $reference) {
      prequalId
      subscriptionId
      accountId
      channel
      acquisitionType
    }
  }
`;

export const getSubscriptionWithEligibilityAndContactDetails = async token => {
  try {
    const { data } = await client.query({
      query: SUBSCRIPTIONS_WITH_ELIGIBILITY_AND_CONTACT_DETAILS,
      variables: {
        token,
      },
    });

    return {
      subscriptions: data.getSubscriptionWithEligibility,
      contactDetails: data.getMyContactDetails,
    };
  } catch (error) {
    console.error(error.graphQLErrors);
    return { error };
  }
};
export const createCrossSellProspect = async ({ accountId = '', token = '' }) => {
  try {
    const variables = {
      accountId: typeof accountId === 'string' ? accountId : JSON.stringify(accountId),
      offerType: 'POSTPAY',
      channel: getCookie('channel')
        ? getCookie('channel')
        : `${publicRuntimeConfig.NEXT_PUBLIC_CHANNEL}`,
      token,
      email: getCookie('email_Address'),
    };
    const { data } = await client.mutate({
      mutation: CREATE_CROSS_SELL_REQUEST,
      variables,
    });
    // set recieved referece to localstorage and cookie.
    return data.createCrossSellProspect;
  } catch (err) {
    throw new Error(err);
  }
};
export const getCrossSellEligiblity = async ({ token, accountId, parentSubscriptionId = null }) => {
  try {
    // console.log('getCrossSellEligiblity', accountId, typeof accountId);
    let variable = {};
    variable = {
      token,
      accountId: Number(accountId),
      parentSubscriptionId,
      reference: await createCrossSellProspect({ accountId, token }),
    };
    if (getCookie('channel') === 'MYEIR') delete variable.reference;

    const { data } = await client.query({
      query: CROSS_SELL_ELIGIBILTY,
      variables: variable,
    });
    // console.log('data for cross sell eligiblity', {
    //   data,
    // });
    return {
      data: {
        ...data.checkCrossSellEligibility,
        error: data.checkCrossSellEligibility?.error || '',
      },
    };
  } catch (error) {
    console.error('ERROR ', error.graphQLErrors);
    return { error, data: {} };
  }
};

export const getMyEirCrossSellEligiblity = async ({
  accountId,
  parentSubscriptionId = null,
  cookies,
}) => {
  try {
    const { data } = await client.query({
      query: CROSS_SELL_ELIGIBILTY,
      variables: {
        token: getTokenFromCookies(cookies),
        accountId: Number(accountId),
        parentSubscriptionId,
      },
    });
    return {
      data: {
        ...data.checkCrossSellEligibility,
        error: data.checkCrossSellEligibility?.error || '',
      },
    };
  } catch (error) {
    console.error('ERROR ', error.graphQLErrors);
    return { error, data: {} };
  }
};

export const getJourneyDetails = async reference => {
  try {
    const { data } = await client.query({
      query: GET_JOURNEY_DETAILS,
      variables: {
        reference,
      },
    });
    setCookie('ION', 'prequal_Id', data?.getJourneyDetails?.prequalId);
    setLocalStorage('prequalid', data?.getJourneyDetails?.prequalId);
    return data?.getJourneyDetails;
  } catch (error) {
    console.error('ERROR ', error.graphQLErrors);
    return { error, data: {} };
  }
};
export const getMyEirJourneyDetails = async reference => {
  try {
    const { data } = await client.query({
      query: GET_JOURNEY_DETAILS,
      variables: {
        reference,
      },
    });
    setCookie('ION', 'prequal_Id', data?.getJourneyDetails?.prequalId);
    return data?.getJourneyDetails;
  } catch (error) {
    console.error('ERROR ', error.graphQLErrors);
    return { error, data: {} };
  }
};
